module.exports = __webpack_public_path__ + "static/img/s125.8f4cda58.png";